module.exports = __webpack_public_path__ + "static/media/dashboard_light.476d4511.svg";